import React from "react";
import styled from "styled-components";
import { VerticalTimelineElement } from "react-vertical-timeline-component";

const Top = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

const Image = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
`;

const Role = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const Company = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Date = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary};
  opacity: 0.7;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const Description = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_primary};
  opacity: 0.9;
  margin-top: 8px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Skills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

const Skill = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.text_primary};
  background: rgba(255, 255, 255, 0.1);
  padding: 2px 8px;
  border-radius: 6px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const ExperienceCard = ({ experience }) => {
  return (
    <VerticalTimelineElement
      date={experience.date}
      icon={
        <Image
          src={experience.img}
          alt={experience.company || experience.role}
        />
      }
      contentStyle={{
        background: "rgba(17, 25, 40, 0.9)",
        color: "#fff",
        boxShadow: "0px 4px 24px rgba(23, 92, 230, 0.15)",
        border: "1px solid rgba(255, 255, 255, 0.125)",
        borderRadius: "8px",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      contentArrowStyle={{
        borderRight: "7px solid rgba(255, 255, 255, 0.3)",
      }}
      iconStyle={{
        background: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onTimelineElementHover={() => {}}
    >
      <Top>
        <Image src={experience.img} alt={experience.role} />
        <Body>
          <Role>{experience.role}</Role>
          <Company>{experience.company}</Company>
          <Date>{experience.date}</Date>
        </Body>
      </Top>

      <Description>
        {experience.desc && <div>{experience.desc}</div>}
        {experience.skills && (
          <Skills>
            {experience.skills.map((skill, idx) => (
              <Skill key={idx}>{skill}</Skill>
            ))}
          </Skills>
        )}
      </Description>
    </VerticalTimelineElement>
  );
};

export default ExperienceCard;
